import {
  IJustification,
  IJustificationActive,
  IJustificationCreate,
  IJustificationParams,
  IJustificationUpdate
} from "src/@types/justification";
import { Paginated } from "src/@types/paginated";
import { Tags } from "../../src/enum/tags";
import { apiSlice } from "./http";

export const justificationInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createJustification: builder.mutation<string, IJustificationCreate>({
      query: (justification: IJustificationCreate) => ({
        url: "/justification",
        method: "POST",
        body: justification,
      }),
      invalidatesTags: [Tags.JUSTIFICATION, Tags.JUSTIFICATION_ACTIVE],
    }),
    updateJustification: builder.mutation<string, IJustificationUpdate>({
      query: (justification: IJustificationUpdate) => ({
        url: `/justification/${justification.id}`,
        method: "PUT",
        body: justification,
      }),
      invalidatesTags: [Tags.JUSTIFICATION, Tags.JUSTIFICATION_ACTIVE],
    }),
    getJustifications: builder.query<
      Paginated<IJustification>,
      IJustificationParams
    >({
      query: ({ search, meta, orderBy }) => {
        const params = new URLSearchParams({
          search: search ?? "",
          orderBy: orderBy ?? "",
          page: (meta?.page ?? 1).toString(),
          perPage: "15",
        });

        return {
          url: `/justification?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: [Tags.JUSTIFICATION],
    }),
    getJustificationActive: builder.query<IJustificationActive[], void>({
      query: () => {
        return {
          url: `/justification/active`,
          method: "GET",
        };
      },

      providesTags: [Tags.JUSTIFICATION_ACTIVE],
    }),
    getJustificationActiveForNsu: builder.query<IJustificationActive[], void>({
      query: () => {
        return {
          url: `/justification/active/nsu`,
          method: "GET",
        };
      },
      providesTags: [Tags.JUSTIFICATION_ACTIVE],
    }),
    getJustificationActiveForDivergence: builder.query<IJustificationActive[], void>({
      query: () => {
        return {
          url: `/justification/active/divergence`,
          method: "GET",
        };
      },
      providesTags: [Tags.JUSTIFICATION_ACTIVE],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetJustificationsQuery,
  useCreateJustificationMutation,
  useUpdateJustificationMutation,
  useGetJustificationActiveQuery,
  useGetJustificationActiveForNsuQuery,
  useGetJustificationActiveForDivergenceQuery,
} = justificationInformations;

export const {
  endpoints: {
    getJustifications: { select: selectGetStores },
    createJustification: { select: selectCreateStore },
    updateJustification: { select: selectUpdateStore },
    getJustificationActive: { select: selectGetStoreActive },
  },
} = justificationInformations;
